import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData, getDefaultUI } from "components/pages/OneTimeACHPaymentPage";
import Classes, { ACHFromAccount, Account } from "model";

export default function CaptureParticipants(props) {
    const context = useBCMSContext();

    BCMSRecord.globalControllerFor(Classes, context);

    const effectiveDate = BCMSDate.init().nextBusinessDay().nextBusinessDay();
    const addedAccount = ACHFromAccount.init({ account: "6", id: ACHFromAccount.nextID(), amount: "5000.00" });

    const { state } = context ?? {};
    const { branding } = state ?? {};
    const { options } = branding ?? {};
    
    let data = BCMSStateManagerCRUD.init(getDefaultData())
        .update([ "oneTimeACHPayment", "transactionType" ], "payment")
        .update([ "oneTimeACHPayment", "secCode" ], "CCD Credit - Non-Consumer Credit")
        .update([ "oneTimeACHPayment", "scheduleType" ], "future dated")
        .update([ "oneTimeACHPayment", "effectiveDate" ], effectiveDate)
        .update([ "oneTimeACHPayment", "companyEntryDescription" ], "ACH PMT")
        .update([ "oneTimeACHPayment", "company" ], "0")
        .update([ "achFromAccounts", "accounts" ], [ addedAccount ]);

    if(options.offset_account_ui_abi22 === "Single Account") {
        data.update([ "selectedOffsetAccount", "account" ], Account.initByID("6"))
    }

    data = data.submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .update([ "showSecCode", "isActive" ], true)
    .update([ "achParticipantsModalIsOpen", "isActive" ], true)
    
    .submit();

    return <OneTimeACHPaymentPage data={ data } ui={ ui } />;
}